import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:8000/portal/";

const api = axios.create({
  baseURL: BASE_URL,
});

// Attach headers automatically before every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const orgId = localStorage.getItem("orgId");
  const deptId = localStorage.getItem("departmentId");

  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  if (orgId && orgId !== "null" && orgId !== "") config.headers["X-Organization-Id"] = orgId;
  if (deptId && deptId !== "null" && deptId !== "") config.headers["X-Department-Id"] = deptId;

  return config;
});

// Track if we're already refreshing to avoid infinite loops
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

const forceLogout = () => {
  localStorage.clear();
  window.location.href = "/login";
};

api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {

      if (isRefreshing) {
        // Queue the request until refresh is done
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refresh_token");

      if (!refreshToken) {
        // No refresh token — force login
        forceLogout();
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${BASE_URL}auth/token/refresh/`, {
          refresh_token: refreshToken,
        });

        const newAccessToken = response.data.token;
        const newRefreshToken = response.data.refresh_token; // always rotated — must persist

        localStorage.setItem("token", newAccessToken);
        if (newRefreshToken) {
          localStorage.setItem("refresh_token", newRefreshToken);
        }

        api.defaults.headers["Authorization"] = `Bearer ${newAccessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);
        return api(originalRequest);

      } catch (refreshError) {

        processQueue(refreshError, null);
        forceLogout();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;